import { REFERENCE } from 'assets/constant';
import BreadCrumb from 'components/shared/BreadCrumb';
import { Sidebar } from 'components/shared/sidebar';
import { useSupporting } from 'hooks';
import { usePatchSupporting } from 'hooks/supporting/usePatchSupporting';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import 'react-quill/dist/quill.snow.css';
import { useNavigate, useParams } from 'react-router';
import { useRecoilValue } from 'recoil';
import { loginUser } from 'recoil/loginUser';
import { handleDownloadFile } from 'util/supporting/noticeUtil';

export const ReferenceDetail = () => {
  const navigate = useNavigate();
  const userInfo = useRecoilValue(loginUser);
  const handleDownLoad = (item) => {
    handleDownloadFile(item);
  };

  const { referenceId } = useParams();

  const { noticeDeleteMutation } = usePatchSupporting();

  const {
    // 자료실 디테일 데이터 불러오기
    referenceDetailData,
    referenceDetailIsLoading,
    referenceDetailIsError,
  } = useSupporting(referenceId, REFERENCE);

  const handleDeleteNotice = () => {
    const checkDelete = window.confirm('정말 삭제하시겠습니까?');
    if (!checkDelete) return;

    try {
      noticeDeleteMutation.mutate(referenceId);
      navigate('/reference');
    } catch (error) {
      console.error('error', error);
    }
  };

  const handleGoingPage = (type) => {
    navigate(`/reference/edit/${referenceId}`);
  };
  const handleGoingList = (type) => {
    navigate(`/reference`);
  };

  return (
    <>
      <Sidebar />
      <main id='main' className='main'>
        <BreadCrumb home={'/reference'} sublink={'/reference'} title={'Help Center'} subTitle={'지원센터'}>
          &nbsp;/ 자료실 / {referenceDetailData?.title}
        </BreadCrumb>
        <section className='card p-20'>
          <div className='fw-bold d-flex justify-content-between align-items-center mt-2 mb-4'>
            <h3>{referenceDetailData?.title}</h3>
            <div className='d-flex'>
              {userInfo?.role === 'ADMIN' && (
                <>
                  <Button
                    onClick={handleGoingPage}
                    className='ms-2'
                    style={{ background: '#0D6EFD' }}
                    variant='secondary'
                  >
                    <i className='bi bi-pencil-fill'></i> 수정
                  </Button>
                  <Button
                    onClick={handleDeleteNotice}
                    className='ms-2'
                    style={{ background: '#6C757D' }}
                    variant='secondary'
                  >
                    <i className='bi bi-trash'></i> 삭제
                  </Button>
                </>
              )}
              <Button onClick={handleGoingList} className='ms-2' style={{ background: '#13426B' }} variant='secondary'>
                <i className='bi bi-list'></i> 목록
              </Button>
            </div>
          </div>
          <div className='d-flex justify-content-between bg-gray10 p-3 border border-start-0 border-end-0'>
            <p className='d-flex flex-column flex-sm-row'>
              <span className='pe-2'>작성자</span>
              <span className='fw-bold text-gray1'>{referenceDetailData?.writer}</span>
            </p>

            <div className='d-flex justify-content-end'>
              <p className='d-flex flex-column flex-sm-row'>
                <span className='pe-2'>등록일</span>
                <span>
                  {referenceDetailData?.createdDate
                    ? moment(referenceDetailData?.createdDate).format('YYYY.MM.DD')
                    : '-'}
                </span>
              </p>
              <p className='d-flex flex-column flex-sm-row'>
                <span className='pe-2'>조회수</span>
                <span>{referenceDetailData?.readCount}</span>
              </p>
            </div>
          </div>
          <div>
            <div
              className='mt-4 mb-2 editorResetStyle'
              dangerouslySetInnerHTML={{ __html: referenceDetailData?.content }}
            ></div>
          </div>
          {referenceDetailData?.mediaInfoDtoList?.length > 0 && (
            <div className='border mx-2 rounded-1 p-2 mb-5 cursor-pointer mt-4'>
              <ul>
                {referenceDetailData?.mediaInfoDtoList?.map((item) => (
                  <li key={item.fileId} className='py-2'>
                    <button
                      onClick={() => {
                        handleDownLoad(item);
                      }}
                      className='d-flex align-items-center justify-content-between bg-none border-none w-100'
                    >
                      <span className='text-blue1'>{item.originalName}</span>
                      <i className='bi bi-download'></i>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </section>
      </main>
    </>
  );
};
